import { useEffect } from 'react';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import { useSmartCardContext } from '@atlaskit/link-provider/use-smart-card-context';

import { preloadSmartLinksForAI } from './resolve-smartlink';

export const SmartLinkAIPreload = ({ editorView }: { editorView: EditorView }) => {
	const { value: context } = useSmartCardContext();
	useEffect(() => {
		if (!context) {
			return;
		}
		const controller = new AbortController();
		const preload = () => {
			if (!editorView.isDestroyed && !controller.signal.aborted) {
				void preloadSmartLinksForAI(context, editorView.state.doc, controller.signal);
			}
		};
		if (window.requestIdleCallback) {
			const id = window.requestIdleCallback(preload);
			return () => {
				controller.abort();
				window.cancelIdleCallback(id);
			};
		}
		const id = window.setTimeout(preload, 1000);
		return () => {
			controller.abort();
			window.clearTimeout(id);
		};
	}, [context, editorView]);
	return null;
};
